<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useDealsStore } from 'dashboard/stores/deals';

import Button from 'dashboard/components-next/button/Button.vue';
import ConfirmDealDeleteDialog from 'dashboard/components-next/Deals/DealCard/ConfirmDealDeleteDialog.vue';
import Policy from 'dashboard/components/policy.vue';

const props = defineProps({
  selectedDeal: { type: Object, required: true },
});

const emit = defineEmits(['deleted']);

const { t } = useI18n();
const dealsStore = useDealsStore();

const confirmDeleteDialogRef = ref(null);
const isDeleting = computed(() => dealsStore.uiFlags.deletingItem);

const openConfirmDeleteDialog = () => {
  confirmDeleteDialogRef.value?.dialogRef.open();
};

const handleConfirmDelete = async () => {
  try {
    await dealsStore.delete(props.selectedDeal.id);
    useAlert(t('DEALS.LIST.DELETE.SUCCESS_MESSAGE'));
    emit('deleted');
  } catch (error) {
    useAlert(error.message ?? t('DEALS.LIST.DELETE.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <Policy :permissions="['administrator']">
    <div class="flex flex-col items-start border-t border-n-strong px-6 py-5">
      <span class="inline-flex text-n-slate-11 text-sm items-center gap-1">
        {{ t('DEALS.LIST.DELETE.SECTION_DESCRIPTION') }}
        <Button
          :label="t('DEALS.LIST.DELETE.CONFIRM')"
          sm
          ruby
          link
          @click="openConfirmDeleteDialog()"
        />
      </span>
    </div>
    <ConfirmDealDeleteDialog
      ref="confirmDeleteDialogRef"
      :deal="selectedDeal"
      :is-loading="isDeleting"
      @confirm="handleConfirmDelete"
    />
  </Policy>
</template>
